/**
 * Normaliza texto para búsqueda: minúsculas, sin tildes/diacríticos.
 * "jabón" y "jabon" producen la misma clave.
 */
export function normalizeSearchText(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** true si query (vacía = match all) aparece en haystack tras normalizar. */
export function searchTextIncludes(haystack, query) {
  const q = normalizeSearchText(query).trim();
  if (!q) return true;
  return normalizeSearchText(haystack).includes(q);
}
